// extracted by mini-css-extract-plugin
module.exports = {"socialItems":"MainFooter_socialItems__3fZfN","footerWrapper":"MainFooter_footerWrapper__2Me5a"};